export default __webpack_public_path__ + "static/media/fooddiary_coverback.63449461.jpg";